<div class="social-connect">
    <h3 class="sso-description sso-description-trainer">
        {{ "authentication.sso.trainer" | translate }}
    </h3>

    <button (click)="onLoginSSOClick()"
            class="submit-button" color="accent" mat-raised-button>
        {{ "authentication.btn-login-sso" | translate }}
    </button>
</div>